import React from 'react';
import { isFieldVisible, getFieldAutoFill } from '@/utils/fieldConfig';
import replaceCustomInputWithSelect from './replaceCustomInputWithSelect';

const ConditionalInput = ({
  children,
  fieldName,
  refundModalType,
  customPaymentType,
  isCustomPaymentTypesEnabled = true,
}) => {
  if (!isCustomPaymentTypesEnabled) {
    return children;
  }
  if (!isFieldVisible(fieldName, refundModalType, customPaymentType)) {
    return null;
  }
  const autoFill = getFieldAutoFill(fieldName, customPaymentType);
  if (autoFill?.type === 'options' && autoFill.options?.length) {
    return React.Children.map(children, (child) =>
      replaceCustomInputWithSelect(child, autoFill.options),
    );
  }
  return children;
};

export default ConditionalInput;
